import { useContext } from 'react';
import { ApplicationContext } from './ApplicationContext';
import { ApplicationDispatchContext } from './ApplicationDispatchContext';
import { IApplicationState } from './state/IApplicationState';
import { TApplicationActionDispatch } from './actions/TApplicationActionDispatch';

export const useApplicationContext = (): [IApplicationState, TApplicationActionDispatch] => {
  const state = useContext(ApplicationContext);
  const dispatch = useContext(ApplicationDispatchContext);
  return [state, dispatch];
};
